import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconSpanner: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 40 40" name="spanner">
    <path
      fillRule="evenodd"
      d="M7.257 11.193a1 1 0 0 1 .908.272l4.125 4.125a2.333 2.333 0 0 0 3.3-3.3l-4.125-4.125a1 1 0 0 1 .336-1.635c1.11-.444 2.94-.856 4.948-.717 2.025.14 4.288.846 6.148 2.706 1.86 1.86 2.566 4.123 2.706 6.148a12.082 12.082 0 0 1-.494 4.314l10.28 10.28-1.414 1.414L23.25 19.951a1 1 0 0 1-.221-1.079c.342-.855.695-2.384.58-4.067-.116-1.668-.687-3.432-2.126-4.872-1.44-1.44-3.204-2.01-4.872-2.125a10.155 10.155 0 0 0-2.525.15l2.918 2.918a4.333 4.333 0 1 1-6.128 6.128l-2.919-2.918c-.137.74-.213 1.61-.15 2.525.116 1.668.686 3.432 2.126 4.872s3.204 2.01 4.872 2.125c1.683.116 3.212-.237 4.067-.579a1 1 0 0 1 1.079.221l10.724 10.725-1.414 1.414-10.28-10.28c-1.11.346-2.65.61-4.314.494-2.025-.14-4.288-.846-6.148-2.706-1.86-1.86-2.566-4.123-2.706-6.148-.14-2.009.273-3.838.717-4.948a1 1 0 0 1 .727-.608Z"
      clipRule="evenodd"
    />
  </Icon>
);
